import { IDotXetHocVuPhamVi } from "../../model/response/xet-hoc-vu/IDotXetHocVuPhamVi";
import { apiClient } from "../apiClient";

const DOT_XET_CHUNG_CHI_PHAM_VI = "dot-xet-chung-chi-pham-vi";
export const dotXetChungChiPhamViApi = {
   SelectByDotXet: (id_dot_xet: number) => apiClient.get(`${DOT_XET_CHUNG_CHI_PHAM_VI}/dot-xet/${id_dot_xet}`),
   Insert: (data: IDotXetHocVuPhamVi) => apiClient.post(DOT_XET_CHUNG_CHI_PHAM_VI, data),
   Delete: (id: number) => apiClient.delete(`${DOT_XET_CHUNG_CHI_PHAM_VI}/${id}`),
}
